// Search boxes whose service builds the PostgREST query string by hand (a raw fetch) need two
// things, and those that wrote `ilike.%term%` got the first wrong:
//  - No raw % in the URL. Supabase's gateway decodes the query string before PostgREST sees it, and
//    a % not followed by two hex digits is not a valid escape — the `%,` or `%)` that ends every
//    `%term%` never is — so it failed the whole request and the browser saw a network error. Every
//    search through those boxes found nothing. `*` is PostgREST's URL-safe alias for the wildcard,
//    and the term itself is URL-encoded.
//  - Inside or=(…) the characters , ( ) are structure, and " \ quote and escape. Each becomes a *
//    wildcard rather than a space, so "Lake Hills (South)" still finds its park.
// Queries built with supabase-js (.or(), .ilike()) are encoded by the client and need neither.

/** What someone typed, ready to search on; undefined when nothing is left. */
export function cleanSearchTerm(raw: string | null | undefined): string | undefined {
  const cleaned = (raw ?? '')
    .replace(/[,()"\\*]+/g, '*')
    .slice(0, 80)
    .replace(/^[\s*]+|[\s*]+$/g, '');
  return cleaned || undefined;
}

/** cleanSearchTerm, once at least `min` characters (wildcards aside) have been typed. */
export function searchTermOfAtLeast(raw: string | null | undefined, min = 2): string | undefined {
  const term = cleanSearchTerm(raw);
  return term && term.replace(/\*/g, '').trim().length >= min ? term : undefined;
}

/** The ilike value for a hand-built query string: `*term*`, URL-encoded. */
export function ilikeValue(term: string): string {
  return `*${encodeURIComponent(term)}*`;
}
